import React from 'react';
import './Payment.scss';
import CloseIcon from '../../../assets/icons/closeModal.svg';
import InfoIcon from '../../../assets/icons/info.svg';
import PaymentIcon from '../../../assets/icons/payment/debit-card_new.svg';

import { paymentMethods, paymentMethodsDescription } from '../../../constants/deliveryData';

interface IPaymentProps {
  onClose: () => void;
}

const Payment: React.FC<IPaymentProps> = ({ onClose }): JSX.Element => {
  return (
    <div className="paymentModal">
      <div className="paymentModal__left">
        <div className="paymentModal__wrapper">
          <div className="paymentModal__icon">
            <PaymentIcon />
          </div>
          <div className="paymentModal__close" onClick={() => onClose()}>
            <CloseIcon />
          </div>
          <h2 className="paymentModal__title">Види оплати</h2>
          <p className="paymentModal__description">
            Після здійснення вами замовлення на нашому сайті, з вами зв`яжеться наш менеджер, для уточнення деталей та узгодження зручного
            для вас варіанту оплати та доставки товарів
          </p>
        </div>
        <div className="paymentModal__wrapper web">
          <div className="paymentModal__item">
            <p className="paymentModal__item-counter">01</p>
            <p className="paymentModal__item-title">{paymentMethods[0].title}</p>
          </div>
          <p className="paymentModal__item-description">{paymentMethods[0].description}</p>
        </div>
        <div className="paymentModal__wrapper web">
          <div className="paymentModal__item">
            <p className="paymentModal__item-counter">02</p>
            <p className="paymentModal__item-title">{paymentMethods[1].title}</p>
          </div>
          <p className="paymentModal__item-description">{paymentMethods[1].description}</p>
        </div>
      </div>
      <div className="paymentModal__right web">
        <div className="paymentModal__wrapper web">
          <div className="paymentModal__item">
            <p className="paymentModal__item-counter">03</p>
            <p className="paymentModal__item-title">{paymentMethods[2].title}</p>
          </div>
          <p className="paymentModal__item-description">{paymentMethods[2].description}</p>
        </div>
        <div className="paymentModal__wrapper web">
          <div className="paymentModal__item">
            <p className="paymentModal__item-counter">04</p>
            <p className="paymentModal__item-title">{paymentMethods[3].title}</p>
          </div>
          <p className="paymentModal__item-description">{paymentMethods[3].description}</p>
        </div>
        <div className="paymentModal__wrapper web">
          <div className="paymentModal__item">
            <p className="paymentModal__item-counter">05</p>
            <p className="paymentModal__item-title">{paymentMethods[4].title}</p>
          </div>
          <p className="paymentModal__item-description">{paymentMethods[4].description}</p>
        </div>
      </div>
      <div className="paymentModal__right mobile">
        {paymentMethods.map(({ id, title, description }) => (
          <div className="paymentModal__wrapper">
            <div className="paymentModal__item">
              <p className="paymentModal__item-counter">0{id}</p>
              <p className="paymentModal__item-title">{title}</p>
            </div>
            <p className="paymentModal__item-description">{description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Payment;
